import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { getFetcher, postFetcher, putFetcher } from "./fetchers";

export const useResource = <T = unknown>(resourceUrl?: string, checkCondition?: unknown) => {
  if (!resourceUrl) {
    return {
      data: null,
      isLoading: false,
      isError: null,
      mutate: () => {},
    };
  }
  const url =
    checkCondition !== undefined ? (checkCondition ? resourceUrl : undefined) : resourceUrl;
  const { data, error, isLoading, mutate } = useSWR<T>(url, getFetcher);

  return {
    data,
    isLoading,
    isError: error,
    mutate,
  };
};

export const usePostResource = (resourceUrl: string, checkCondition?: unknown) => {
  const url =
    checkCondition !== undefined ? (checkCondition ? resourceUrl : undefined) : resourceUrl;
  const { trigger, data, isMutating } = useSWRMutation(url, postFetcher);

  return {
    data,
    updateResource: trigger,
    isMutating,
  };
};

export const usePutResource = (resourceUrl: string) => {
  const { trigger, data, isMutating } = useSWRMutation(resourceUrl, putFetcher);

  return {
    data,
    updateResource: trigger,
    isMutating,
  };
};
